export function createMarkup(htmlString) {
  return { __html: htmlString };
}

export function idFromText(text) {
  return text.replaceAll(" ", "-").toLowerCase();
}
